export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: !that.disabled && that.restockStatus !== 'N',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    showHeaderOverflow: true,
    visible: !that.disabled && that.restockStatus !== 'N',
    slots: { default: 'opt' },
  },
  {
    field: 'defaultImage',
    width: 70,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'left',
    align: 'left',
    slots: { default: 'defaultImage' },
  },
  {
    title: that.$l('table_label_displaySku') || '产品信息',
    field: 'displaySku',
    headerAlign: 'left',
    align: 'left',
    minWidth: 220,
    slots: { default: 'displaySku' },
  },
  {
    title: that.$l('table_label_displayStore') || '销售信息',
    field: 'displayStore',
    headerAlign: 'left',
    align: 'left',
    minWidth: 220,
    slots: { default: 'displayStore' },
  },
  {
    title: that.$l('table_label_displaySubmitQty') || '补货数量',
    field: 'displaySubmitQty',
    headerAlign: 'left',
    align: 'left',
    minWidth: 120,
    showHeaderOverflow: true,
    slots: { default: 'displaySubmitQty' },
  },
  {
    title: that.$l('table_label_displayOperate') || '运营信息',
    field: 'displayOperate',
    headerAlign: 'left',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    slots: { default: 'displayOperate' },
    visible: that.isVc == 'N',
  },
  {
    title: that.$l('table_label_displayReply') || '采购返答',
    field: 'displayReply',
    headerAlign: 'left',
    align: 'left',
    minWidth: 450,
    showHeaderOverflow: true,
    slots: { default: 'displayReply' },
  },
]
